import BaseOverlayPanel from "../../sisu/overlay/BaseOverlayPanel.sisu";

export default BaseOverlayPanel;